export default {
  CDN_JS_URL: 'https://cdn.jsdelivr.net/npm/autofill-js@2.0.2/dist/js/autofill.min.js',
  CDN_CSS_URL: 'https://cdn.jsdelivr.net/npm/autofill-js@2.0.2/dist/css/autofill.min.css',
  DEV_HOSTS: [
    '127.0.0.1:5100',
    '127.0.0.1:5101',
  ],
}
